snt-blog-results {
    snt-multi-column-mixed snt-image img {
        position: unset;
        top: unset;
    }

    snt-multi-column-mixed.first-row {
        .row { 
            padding-bottom: 20px;
        }
    }

    snt-multi-column-mixed.result-rows {
        .spacings {
            padding-top: 10px;
        }
    }
}

